/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewtopempty3Inputs */

const en_sharereviewtopempty3 = /** @type {(inputs: Sharereviewtopempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No cashback this month yet.`)
};

const de_sharereviewtopempty3 = /** @type {(inputs: Sharereviewtopempty3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Monat noch kein Cashback.`)
};

/**
* | output |
* | --- |
* | "No cashback this month yet." |
*
* @param {Sharereviewtopempty3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewtopempty3 = /** @type {((inputs?: Sharereviewtopempty3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewtopempty3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewtopempty3(inputs)
	return de_sharereviewtopempty3(inputs)
});
export { sharereviewtopempty3 as "shareReviewTopEmpty" }